export const TABLE_COL_WIDTH = 150;
export const TABLE_COL_WIDTH_ALTERNATIVE = 114;
export const TABLE_LABELS_COL_WIDTH = 217;
export const TABLE_LABELS_COL_WIDTH_ALTERNATIVE = 286;
export const TABLE_LABELS_COL_WIDTH_OPM_INPUTS = 330;
export const DEAL_THESIS_TABLE_HEADER_ADDITIONAL_COL_COUNT = 3;
export const OPM_TABLE_HEADER_ADDITIONAL_COL_COUNT = 3;
export const OPM_TABLE_DATA_ADDITIONAL_COL_COUNT = 1;
export const DEAL_THESIS_EXIT_MULTIPLE_FIXED_HEADER_COUNT = 5;
